<template>
  <InputSwitch id="show-info" v-model="showPaymentInfo" @click.stop>
    <template #valueText>
      {{ t('sites.singleSite.financialConfig.paymentInfo.form.showInfo') }}
    </template>
  </InputSwitch>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { InputSwitch } from '@centric-os/components/src/core/controls/input-switch';
import { storeToRefs } from 'pinia';
import { usePaymentInfoStore } from '../../../../../../routes';

// Set localization
const { t } = useI18n();

// Set payment info store
const paymentInfoStore = usePaymentInfoStore();
const { showPaymentInfo } = storeToRefs(paymentInfoStore);
</script>
